import { StandardFilter } from './standard-filter';

export class TenantFilter extends StandardFilter {
  /**
   * Gets or sets the tenant UUID.
   * Used to make sure we don't load data from another tenant.
   */
  declare public tenantUuid: string | null;
}
